/* use JavaScript pass by reference i.e for productConfiguration array */
var transformHomeServicesProducts = function transformHomeServicesProducts(homeServices, productConfiguration) {
  if (homeServices != null && homeServices.testDrive) {
    productConfiguration.push('dhs-test-drive');
  }
  if (homeServices != null && homeServices.vehicleDelivery) {
    productConfiguration.push('dhs-deliver');
  }
  if (homeServices != null && homeServices.virtualTour) {
    productConfiguration.push('dhs-video');
  }
  if (homeServices != null && homeServices.accelerate) {
    productConfiguration.push('online-paperwork');
  }
  if ((homeServices == null ? void 0 : homeServices.serviceInquiry) === 'scheduleTestDrive') {
    productConfiguration.push('schedule-test-drive');
  }
  if (homeServices != null && homeServices.buyOnline) {
    productConfiguration.push('buy-online');
  }
};
export function transformProductConfig(products, includeWalletData) {
  if (products === void 0) {
    products = {};
  }
  if (includeWalletData === void 0) {
    includeWalletData = false;
  }
  var productConfiguration = [];
  var _products = products,
    _products$homeService = _products.homeServices,
    homeServices = _products$homeService === void 0 ? {} : _products$homeService,
    nds = _products.nds,
    wallet = _products.wallet,
    shippingLabel = _products.shippingLabel,
    creditApp = _products.creditApp,
    westlake = _products.westlake;
  transformHomeServicesProducts(homeServices, productConfiguration);
  if (wallet || includeWalletData) productConfiguration.push('my-wallet');
  if (nds) productConfiguration.push('nds');
  if (shippingLabel) productConfiguration.push('me-delivery');
  if (creditApp) productConfiguration.push('credit-app');
  if (westlake) productConfiguration.push('westlake');
  return {
    productConfiguration: productConfiguration.length > 0 ? productConfiguration.join('|') : undefined
  };
}
export var hasPrice = function hasPrice(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    pricingDetail = _ref.pricingDetail;
  return (pricingDetail == null ? void 0 : pricingDetail.salePrice) || (pricingDetail == null ? void 0 : pricingDetail.msrp);
};
export default {
  transformProductConfig: transformProductConfig,
  hasPrice: hasPrice
};